import { Flex } from "@chakra-ui/layout";
import { useDisclosure } from "@chakra-ui/react";
import { useExcluirAnimal } from "core/features/animal/hooks/useExcluirAnimal";
import { useListarAnimais } from "core/features/animal/hooks/useListarAnimais";
import {
  showConfirm2,
  showErrorAxios,
  showSuccess,
  useLoading,
} from "infra/helpers/alerta";
import useFiltro from "infra/helpers/useFiltro";
import { useState } from "react";
import PrimaryButton from "ui/components/Button/PrimaryButton";
import NewTable from "ui/components/NewTable";
import ModalCadastroPet from "./components/ModalCadastroPet";
import useTabelaPetsColumns from "./hooks/useTabelaPetsColumns";

function TabPets({ unidadeId }: { unidadeId: string }) {
  const { isOpen: isOpenModal, onToggle: onToggleModal } = useDisclosure();
  const [idEdit, setIdEdit] = useState<string | undefined>();
  const columns = useTabelaPetsColumns();
  const { filtro, onChangeFiltro } = useFiltro();
  const { data, isLoading, isFetching, refetch } = useListarAnimais({
    ...filtro,
    unidadeId,
  });

  const { isLoading: isLoadingDelete, mutate: handleDelete } =
    useExcluirAnimal();

  useLoading(isLoadingDelete);

  return (
    <>
      {isOpenModal ? (
        <ModalCadastroPet
          onSaved={() => {
            refetch();
          }}
          id={idEdit}
          isOpen={isOpenModal}
          onClose={() => {
            setIdEdit(undefined);
            onToggleModal();
          }}
          unidadeId={unidadeId}
        />
      ) : null}

      <NewTable
        title={() => (
          <Flex>
            <Flex>
              <PrimaryButton
                onClick={(ev) => {
                  ev.stopPropagation();
                  onToggleModal();
                }}
              >
                Adicionar
              </PrimaryButton>
            </Flex>
          </Flex>
        )}
        actions={[
          {
            title: "Editar",
            onClick: (v) => {
              setIdEdit(v.id);
              onToggleModal();
            },
          },
          {
            title: "Excluir",
            onClick: (v) => {
              showConfirm2({
                onOk: () => {
                  handleDelete(v.id, {
                    onSuccess: () => {
                      setTimeout(() => {
                        showSuccess().then(() => {
                          if (filtro.page! > 1) {
                            onChangeFiltro("page", 1);
                          } else {
                            refetch();
                          }
                        });
                      }, 250);
                    },
                    onError: (err) => {
                      setTimeout(() => {
                        showErrorAxios(err);
                      }, 250);
                    },
                  });
                },
              });
            },
          },
        ]}
        loading={isLoading || isFetching}
        dataSource={data?.items ?? []}
        customPagination={{
          currentPage: data?.meta.currentPage ?? 0,
          itemsPerPage: data?.meta.itemsPerPage ?? 0,
          totalItems: data?.meta.totalItems ?? 0,
          onChangePage: (p) => onChangeFiltro("page", p),
        }}
        columns={columns}
      />
    </>
  );
}

export default TabPets;
